import { type ParsedButton } from "@dotcom/dato";
import { Button, type ParsedImageSet, Image } from "@dotcom/ui";
import styled from "@emotion/styled";
import {
  AspectRatios,
  Card,
  Orientations,
  Paragraph,
} from "@polestar/component-warehouse-react";

export interface FeaturedPartnersTileProps {
  readonly title?: string;
  readonly body?: string;
  readonly button?: ParsedButton;
  readonly imageSet: ParsedImageSet;
}

const StyledParagraphBody = styled(Paragraph)`
  white-space: pre-line;
`;

const FeaturedPartnersTile = ({
  button,
  body,

  title,
  imageSet,
}: FeaturedPartnersTileProps) => {
  return (
    <Card
      media={
        <Image
          imageSet={imageSet}
          widths={{
            desktopWide: 384,
            desktop: 384,
            tablet: 320,
            mobile: 327,
          }}
        />
      }
      mediaAspectRatio={{
        mobile: AspectRatios.wide,
        tablet: AspectRatios.square,
        desktop: AspectRatios.square,
      }}
      title={title}
      body={<StyledParagraphBody>{body}</StyledParagraphBody>}
      actions={
        button && (
          <Button
            label={button.label}
            href={button.href}
            variant={button.variant}
            openInNewTab={button.openInNewTab}
            icon={button.icon}
          />
        )
      }
      orientation={Orientations.vertical}
    />
  );
};

export default FeaturedPartnersTile;
